module.exports = "https://static.wagwalking.com/_next/static/images/petresource-dog-parks-4a095b88b480bc9917948bc4a26ce30c.svg";